import actionTypes from '../../actionTypes'
import initial from '../../initial'

const onboarding = (state = initial.onboarding, action) => {
  switch (action.type) {
  case actionTypes.SET_ONBOARDING_PROCESS:
    return { ...state, onboardingProcess: action.payload }
  case actionTypes.SET_CREATE_PROJECT:
    return { ...state, createProject: action.payload }
  case actionTypes.SET_INSTALL_TOOL:
    return { ...state, installTool: action.payload }
  case actionTypes.SET_CREATE_SECRET:
    return { ...state, createSecret: action.payload }
  case actionTypes.SET_CREATE_ACCESS_KEY:
    return { ...state, createAccessKey: action.payload }
  case actionTypes.SET_CHANGE_PROCESS_KEY:
    return { ...state, changeProcessKey: action.payload }
  default:
    return state
  }
}

export default onboarding
